import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEyeOff12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEyeOff12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#EyeOff12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m2.894 9.85-.585.585a.5.5 0 1 1-.708-.707l8.164-8.163a.5.5 0 1 1 .707.707l-.493.493c.8.711 1.383 1.533 1.763 2.17a2.06 2.06 0 0 1 0 2.13c-.845 1.417-2.693 3.745-5.705 3.745-1.242 0-2.286-.396-3.143-.96M9.27 3.473c.708.616 1.243 1.353 1.614 1.974.206.346.206.76 0 1.105-.81 1.356-2.398 3.258-4.847 3.258a4.6 4.6 0 0 1-2.418-.686l.92-.92a2.665 2.665 0 0 0 3.702-3.702zM7.513 5.23 5.267 7.476q.16.083.34.132A1.665 1.665 0 0 0 7.512 5.23M6.037 2.19c.585 0 1.121.108 1.61.292l.764-.764a5.5 5.5 0 0 0-2.374-.529c-3.012 0-4.86 2.329-5.706 3.746a2.06 2.06 0 0 0 0 2.13 10 10 0 0 0 1.16 1.572L2.2 7.93a9 9 0 0 1-1.01-1.378 1.06 1.06 0 0 1 0-1.105C2 4.092 3.589 2.19 6.038 2.19"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="EyeOff12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconEyeOff12);
